<template>
  <SmallSquare class="m-b-25 m-t-15" content='1 、微信内容同步每项每天限3次。
  2 、素材库同步：每次同步素材数量限100，若素材总数超过100，则优先同步最近创建过的100个素材。（超过2M的音频素材无法同步到本地）
  3 、自定义菜单同步：把最近一次发布的菜单内容同步到本地。（数据权限问题，微信公众平台的卡券暂时无法同步到本地）。
  4 、自动回复同步：把微信公众平台的自动回复同步到本地。（同步后请把微信公众平台的设置删除，否则公众号会回复两次相同的内容） 
  注：由于微信接口限制，自定义菜单、自动回复设置了回复图片，从微信同步过来后，图片会在三天后失效，请在本地重新设置。'></SmallSquare>
  <a-layout class='index animated fadeIn'>
    <div class="s_bf p-t-15">
      <a-checkbox-group v-model:value="form.type">
        <div class="p-l-20 m-b-15">
          <a-checkbox :value="1">同步素材库内容</a-checkbox>
        </div>
        <div class="p-l-20 m-b-15">
          <a-checkbox :value="2">同步自定义菜单内容</a-checkbox>
        </div>
        <div class="p-l-20 m-b-15">
          <a-checkbox :value="3">同步自动回复内容</a-checkbox>
        </div>
         <div class="p-l-20 m-b-15">
          <a-checkbox :value="4">同步音频素材</a-checkbox>
        </div>
         <div class="p-l-20 m-b-15">
          <a-checkbox :value="5">同步视频素材</a-checkbox>
        </div>
        <a-button class="m-l-20 m-t-40" type="primary" v-has:wxSynchronizeSet="onSubmit">确认同步</a-button>
      </a-checkbox-group>
    </div>
  </a-layout>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { getAgentList } from "@/api/agent";
  import { iscode } from "@/utils/app";
  import {setSynchro} from '@/api/public_wx.js'
  let defSearch = {
    type: [],
  };
  export default {
    cardList: 'syncList',
    components: {  },
    setup(props, ctx) {
      let form = ref({ ...defSearch });
      const state = reactive({
        listLoading: false,
        total: 1,
        labelCol: { span: 4 },
        wrapperCol: { span: 16 }
      });
      const $router = inject('$router')

      const onSubmit=async()=>{
       const hide = message.loading('正在加载中...', 0);
       let result=await setSynchro(form.value).then(res=>res.data).catch(error=>error)
       form.value.type=[]
       setTimeout(hide)
       iscode(result,true)
      }
      onMounted(() => {
      });
      return {
        ...toRefs(state),
        form,
        onSubmit
      };
    },
  };
</script>